<template>
	<button type="button" @click="redirectToCrm(userState)">
		<slot />
	</button>
</template>

<script setup lang="ts">
	import type {UserState} from '~/stores/crmStateStore';

	type Props = {
		userState: UserState;
	};

	defineProps<Props>();

	const {redirectToCrm} = useCrmRedirect();
</script>
